import "../scss/styles.scss";
import PageCommon	from "./pages/PageCommon.js";
import PageDefault	from "./pages/PageDefault.js";
import PageGeneric from "./pages/PageGeneric.js";
import PageCreateAccount from "./pages/PageCreateAccount.js";
import PageLoop from "./pages/PageLoop.js";
import PageSingle from "./pages/PageSingle.js";
import PageObserve from "./pages/PageObserve.js";
import PageProfilo from "./pages/PageProfilo.js";
import PageSearch from "./pages/PageSearch";
import PageDefaultTest	from "./pages/PageDefaultTest.js";
import PageLoopTest from "./pages/PageLoopTest.js";

import ServiceManager from "./3x1010/services/ServiceManager.js";

export default class App {

	static factory(cls) {
		return new App.classes[cls]();
	}

}
// PAGINE
App.classes = {
	PageCommon,
	PageDefault,
	PageGeneric,
	PageLoop,
	PageSingle,
	PageObserve,
	PageCreateAccount,
	PageProfilo,
	PageSearch,
	PageDefaultTest,
	PageLoopTest
};

// ALTRE CLASSI ESPORTATE ESPLICITAMENTE
window.Class = {};
window.Class.ServiceManager = ServiceManager;
window.Class.PageCommon = PageCommon; 